import { apiClient } from '../client';
import type { CreateUserDto, UpdateUserDto } from '../dto/user.dto';

export async function createUser(data: CreateUserDto) {
    return apiClient.post('/users', data);
}

export async function updateUser(userId: string, data: UpdateUserDto) {
    return apiClient.put(`/users/${userId}`, data);
}